import { booleanAttribute } from "#ce/utils/props";

export const props = Object.freeze({
  /**
   * The applied visit type, as the comma-joined id list the `visit_types` search
   * param carries. Matched against a row's `value`.
   */
  modelValue: {
    type: String,
    default: undefined,
  },
  label: {
    type: String,
    default: "Visit Type",
  },
  /** Title shown above the visit type options in the open menu. */
  menuTitle: {
    type: String,
    default: undefined,
  },
  /**
   * Title of the row that clears the filter.
   */
  anyLabel: {
    type: String,
    default: undefined,
  },
  /**
   * Per-category titles for the top-level rows, keyed by visit-type category
   * (`{"in-person": "In-person visits only"}`). A category with no entry keeps the
   * server's own wording. Arrives as a JSON string from the server-rendered mount.
   *
   * @type {Object|String}
   */
  categoryLabels: {
    type: [Object, String],
    default: undefined,
  },
  /**
   * Accessible label for the accordion branch disclosure toggle that expands a
   * category's named visit types. `aria-expanded` conveys the open/closed state.
   */
  branchToggleLabel: {
    type: String,
    default: undefined,
  },
  /** Message shown in the dropdown when the domain offers no visit types. */
  noDataText: {
    type: String,
    default: undefined,
  },
  /** Message shown in the dropdown when the options could not be loaded. */
  errorText: {
    type: String,
    default: undefined,
  },
  prependIcon: {
    type: String,
    default: "appointment-type-filled",
  },
  appendIcon: {
    type: String,
    default: "popup-arrow-filled",
  },
  /** Endpoint override for the visit-type options. */
  url: {
    type: String,
    default: undefined,
  },
  /** @type {Boolean|String} */
  hideTitleBar: booleanAttribute(),
  /** @type {Boolean|String} */
  hidePointer: booleanAttribute(),
  /** @type {Boolean|String} */
  open: booleanAttribute(),
  location: {
    type: String,
    default: undefined,
  },
  /** @type {Boolean|String} */
  inline: booleanAttribute(),
  /** @type {Boolean|String} */
  closeOnSelect: booleanAttribute(),
  /** @type {Boolean|String} */
  readonly: booleanAttribute(),
});
